export default __webpack_public_path__ + "static/media/helmet.bf81cc2c.svg";